module.exports = __webpack_public_path__ + "static/media/gallery_03.073ffbd9.png";